"use client";

import { c as _c } from "react/compiler-runtime";
import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";
export const Calendar = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-h3 leading-h3 tracking-h3 font-medium text-white mt-5">Ready to build your next store?</h2>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="px-4 pb-12 text-center max-w-2xl mx-auto">{t1}<p className="text-pregular leading-pregular tracking-pregular text-[#bfbfbf] mt-6 mb-5">Schedule a personalized onboarding session with our team. <br />Let's get you started.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="bg-neutral-900" id="calendar"><div className="max-w-[1250px] mx-auto"><div className="yns-bg-gradient [--color:#2c2c2c] pt-12 pb-14 md:py-24">{t2}<Cal namespace="demo" calLink="yournextstore/demo" style={{
            width: "100%",
            height: "100%",
            overflow: "scroll"
          }} config={{
            layout: "month_view",
            theme: "dark"
          }} />;</div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
async function _temp() {
  const cal = await getCalApi({
    namespace: "demo"
  });
  cal("ui", {
    theme: "dark",
    cssVarsPerTheme: {
      light: {
        "cal-brand": "#171717"
      },
      dark: {
        "cal-brand": "#635bff"
      }
    },
    hideEventTypeDetails: false,
    layout: "month_view"
  });
}
function _temp2() {
  _temp();
}